export const STORE_LOCATOR_CONFIGS = {
    isDevelopment: process.env.NODE_ENV === 'development',
    defaultCenter: { // UK
        latitude: 54.7023545,
        longitude: -3.2765753
    },
    countryCode: 'GB',
    defaultCityLocation: { // London
        latitude: 51.5074,
        longitude: -0.1278
    },
    initialZoom: 6,
    centerZoom: 15,
    disableDefaultUI: false,
    gestureHandling: 'greedy',
    // Map theme selection
    mapTheme: 'custom', // Options: 'default', 'custom'
    STORE_LOCATOR_DISTANCE: 50,
    NUM_STORES_PER_REQUEST_API_MAX: 200,
    STORE_LOCATOR_DISTANCE_UNIT: 'km',
    getDirectionURL: 'https://maps.google.com/?daddr='
}
